import MenuIcon from '@mui/icons-material/Menu';
import PropTypes from 'prop-types';
import React from 'react';
import RouterIcon from '@mui/icons-material/Router';
import {API_TYPE} from '@account/config';
import {Box, Hidden, IconButton} from '@mui/material';
import {DARK_THEME} from '@apps-common/ui-theme/Themes';
import {NavBar} from '@apps-common/ui-components';
import {ThemeProvider} from '@emotion/react';
import {hasRoleLevel, roleLevels} from '@account/utils';
import {useAuth} from '@apps-common/auth-react';

const getApiInfo = () => {
  const color = {
    live: 'success',
    next: 'info',
    local: 'error',
    edition: 'warning',
  }[API_TYPE];

  return {
    icon: <RouterIcon />,
    label: API_TYPE,
    color,
    sx: {
      backgroundColor: theme => theme.palette[color].dark,
      color: theme => theme.palette[color].light,
    },
  };
};

const AppBar = ({onMenuClick}) => {
  const auth = useAuth();

  const isPlaneteer = hasRoleLevel(auth, [
    roleLevels.planet_user,
    roleLevels.planet_admin,
  ]);

  return (
    <ThemeProvider theme={DARK_THEME}>
      <NavBar
        title="Account"
        {...(API_TYPE !== 'live' && isPlaneteer
          ? {titleChipProps: getApiInfo()}
          : {})}
        primary={
          <Hidden smUp>
            <Box marginLeft={1}>
              <IconButton
                onClick={onMenuClick}
                edge="start"
                color="inherit"
                aria-label="menu"
                size="small"
                style={{padding: 0}}
                data-qe="applications-menu"
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </Hidden>
        }
        user={auth.user?.claims}
        logout={auth.signOut}
        userMenuProps={{showAccountLink: false}}
        sx={{zIndex: theme => theme.zIndex.drawer + 1}}
      />
    </ThemeProvider>
  );
};
AppBar.propTypes = {
  onMenuClick: PropTypes.func,
};

export default AppBar;
